<template lang="html">
  <!-- <v-app id="inspire" dark>
    <v-navigation-drawer fixed :clipped="$vuetify.breakpoint.lgAndUp" app v-model="drawer" class="hidden-md-and-up">
      <v-list dense>
        <template v-for="item in items">
          <v-layout row v-if="item.heading" align-center :key="item.heading">
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
          </v-layout>
          <v-list-tile @click="toPage(item.link)" :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app fixed clipped-left>
      <v-toolbar-side-icon @click.stop="drawer =! drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <v-toolbar-title>QRCODE</v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="hidden-md-and-down"><h3>oat.ms@thaimail.com</h3></span>
      <v-tooltip bottom>
        <v-btn fab dark small slot="activator" color="indigo" @click="backPage">
          <v-icon>home</v-icon>
        </v-btn>
        <span>หน้าแรก</span>
      </v-tooltip>
    </v-toolbar> -->
    <div class="">
      <QrcodeReader :paused="paused" @decode="onDecode">
        <div v-show="paused" class="validation-layer">
          <div class="decode-result">
            <u>ถอดรหัส QRCODE</u>: {{ content }}
          </div>
          <div class="validation-notice">
            <div v-if="validating">
              กำลังประมวลผล...
            </div>
            <div v-else-if="isValid" class="text-success">
              สำเร็จ
            </div>
            <div v-else class="text-danger">
              โปรดสแกน QRCODE ใหม่อีกครั้ง
            </div>
          </div>
        </div>
        <LoadingIndicator/>
      </QrcodeReader>
    </div>
  <!-- <v-footer color="blue-grey darken-3" app fixed>
    <v-flex xs12 py-3 text-xs-center white--text>
      &copy; {{ new Date().getFullYear() }} Internet Thailand Public Company Limited
    </v-flex>
  </v-footer> -->
<!-- </v-app> -->
</template>

<script>
import { QrcodeReader } from 'vue-qrcode-reader'
export default {
  components: { QrcodeReader },
  data: () => ({
    drawer: null,
    isValid: false,
    validating: false,
    paused: false,
    content: null,
    shareholder: [],
    items: [
      { icon: 'home', text: 'Home', link: '/' }
    ],
    nametest: []
  }),
  methods: {
    toPage (url) {
      this.$router.push(url)
    },
    backPage () {
      window.location = '/'
    },
    async onDecode (content) {
      this.content = content
      this.pauseCamera()
      this.validating = true
      this.isValid = true
      // this.isValid = await this.validate('/vote/', content)
      this.validating = false
      window.setTimeout(() => {
        this.unPauseCamera()
      }, 2000)
      if (content !== '') {
        this.$router.push('/vote/m' + content)
      }
    },
    pauseCamera () {
      this.paused = true
    },
    unPauseCamera () {
      this.paused = false
    }
    // validate (url, content) {
    //   return new Promise(resolve => {
    //     this.$router.push(url + '/' + this.content)
    //     // window.setTimeout(() => { // pretend it's taking really long
    //     //   resolve(true)
    //     // }, 3000)
    //   })
    // }
  }
}
</script>

<style lang="css" scoped>
video {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
}
.validation-layer {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  background-color: rgba(0, 0, 0, .8);
  text-align: center;
  padding: 10px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.validation-notice {
  font-weight: bold;
  font-size: 1.4rem;
}
.decode-result {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/QRScaner.vue